import Flex from "@ui-kit/layout/Flex/Flex.web";
import Link from "@ui-kit/navigation/Link/Link.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useUserSessionAuthState } from "@shared/modules/auth/contexts/useUserSessionAuthState";
import { useTranslation } from "@shared/utils/internationalization";
import { useMemo } from "react";
import {
  voucherCodeForTT,
  voucherForTT,
  voucherNotRequired,
} from "../../utils/ticket-type-utils";
import { TicketVoucherTextProps } from "./TicketVoucherText.props";

const TicketVoucherText = ({
  userVouchers,
  basketVoucherCode,
  type,
  eventUrl,
  venueSlug,
  venueName,
}: TicketVoucherTextProps) => {
  const { t } = useTranslation("purchases");
  const { isLoggedIn } = useUserSessionAuthState();

  const isRequiredVoucher = useMemo(
    () => !voucherNotRequired(type, userVouchers),
    [voucherNotRequired, type, userVouchers]
  );
  const voucher = useMemo(
    () => voucherForTT(type, userVouchers),
    [voucherForTT, type, userVouchers]
  );
  const voucherCode = useMemo(
    () => voucherCodeForTT(type, userVouchers),
    [voucherCodeForTT, type, userVouchers]
  );

  const showRequiresCreditText = useMemo(
    () =>
      isRequiredVoucher ||
      (type.voucher_purchases_only && basketVoucherCode === ""),
    [isRequiredVoucher, type, basketVoucherCode]
  );

  return (
    <Flex direction="column" mt="xs">
      {!isRequiredVoucher && voucher && (
        <Text>
          {`${t("*Selecting this ticket will apply credit code")}: `}
          <Link
            href="/account/credits/"
            color="secondary.600"
            textDecoration="underline"
          >
            {voucherCode}
          </Link>
        </Text>
      )}
      {showRequiresCreditText && (
        <Text>
          {t("*This ticket type can only be obtained using a ticket credit.")}
        </Text>
      )}
      {isRequiredVoucher && (
        <Text>
          {t("*Visit ")}
          <Link
            href={`/o/${venueSlug}`}
            color="secondary.600"
            textDecoration="underline"
          >
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            {venueName}'s {t("Profile Page")}
          </Link>
          {t(" to find a listing of their events and packages.")}
        </Text>
      )}
      {isRequiredVoucher && !isLoggedIn && (
        <Text>
          {t("*If you already have a ticket credit, please ")}
          <Link
            href={`/accounts/login/?next=${eventUrl}`}
            color="secondary.600"
            textDecoration="underline"
          >
            {t("login")}
          </Link>
          {t(" to your account.")}
        </Text>
      )}
    </Flex>
  );
};

export default TicketVoucherText;
